import ReactDOM from 'react-dom/client';
import React from 'react';
import { InvestmentRobot } from '../components/investment-robot/InvestmentRobot';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import Chart from 'chart.js';

/* eslint import/no-webpack-loader-syntax: off */
import css from '!raw-loader!../styles/style.css';
import sliderCSS from '!raw-loader!rc-slider/assets/index.css';
import toggleCSS from '!raw-loader!react-toggle/style.css';

import { CLIENT_DETAILS_OPTIONS, ROBOT_ENVIRONMENT } from '../config/constants';

/* This is needed to allow custom elements to be accepted by JSX as an element */
declare global {
    namespace JSX {
        interface IntrinsicElements {
            'investment-robot': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> & {
                environment: ROBOT_ENVIRONMENT;
                googleAnalyticsCode?: string;
            };
        }
    }
}

// Disable chart data labels, use plugin on a per chart basis
Chart.plugins.unregister(ChartDataLabels);

export class InvestmentRobotElement extends HTMLElement {
    connectedCallback() {
        const mountPoint = document.createElement('div');
        mountPoint.classList.add('responsive-container');
        const styleNode = document.createElement('style');
        const tealiumNode = document.createElement('script');
        tealiumNode.type = 'text/javascript';
        tealiumNode.innerHTML = `
            (function(a,b,c,d){
            a='https://tags.tiqcdn.com/utag/bnd/webcomponents/prod/utag.js';
            b=document;c='script';d=b.createElement(c);d.src=a;d.type='text/java'+c;d.async=true;
            a=b.getElementsByTagName(c)[0];a.parentNode.insertBefore(d,a);
            })();
        `;
        const shadow = this.attachShadow({ mode: 'open' });
        styleNode.innerHTML = `${sliderCSS} ${toggleCSS} ${css}`;
        shadow.appendChild(styleNode);
        // shadow.appendChild(tealiumNode);
        shadow.appendChild(mountPoint);

        const environment = this.getAttribute('environment') as ROBOT_ENVIRONMENT;
        const contactDetailsOption = this.getAttribute('contactDetailsOption') as CLIENT_DETAILS_OPTIONS;
        const ga = this.getAttribute('googleAnalyticsCode') ?? (undefined as string | undefined);

        const root = ReactDOM.createRoot(mountPoint); // Initialize the root
        root.render(
            <InvestmentRobot
                environment={environment ? environment : 'Marketing'}
                googleAnalyticsCode={ga}
                contactDetailsOption={contactDetailsOption ? contactDetailsOption : 'default'}
            />,
        );

        var ro = new ResizeObserver((entries) => {
            for (let entry of entries) {
                if (entry.contentRect.width >= 1536) {
                    !entry.target.classList.contains('container-2xl') && entry.target.classList.add('container-2xl');
                } else {
                    entry.target.classList.contains('container-2xl') && entry.target.classList.remove('container-2xl');
                }

                if (entry.contentRect.width >= 1280) {
                    !entry.target.classList.contains('container-xl') && entry.target.classList.add('container-xl');
                } else {
                    entry.target.classList.contains('container-xl') && entry.target.classList.remove('container-xl');
                }

                if (entry.contentRect.width >= 1024) {
                    !entry.target.classList.contains('container-lg') && entry.target.classList.add('container-lg');
                } else {
                    entry.target.classList.contains('container-lg') && entry.target.classList.remove('container-lg');
                }

                if (entry.contentRect.width >= 768) {
                    !entry.target.classList.contains('container-md') && entry.target.classList.add('container-md');
                } else {
                    entry.target.classList.contains('container-md') && entry.target.classList.remove('container-md');
                }

                if (entry.contentRect.width >= 640) {
                    !entry.target.classList.contains('container-sm') && entry.target.classList.add('container-sm');
                } else {
                    entry.target.classList.contains('container-sm') && entry.target.classList.remove('container-sm');
                }
            }
        });

        // Observe one or multiple elements
        if (shadow.querySelector('.responsive-container')) {
            ro.observe(shadow.querySelector('.responsive-container')!);
        }
    }
}

export const registerInvestmentRobotElement = () => {
    if (!window.customElements.get('investment-robot')) {
        window.customElements.define('investment-robot', InvestmentRobotElement);

        /** This needs to be done as Shadow DOM cannot process font face css rules. */
        const fontLinkNode = document.createElement('link');
        fontLinkNode.rel = 'stylesheet';
        fontLinkNode.href = 'https://use.typekit.net/zui6lvf.css';
        window.document.head.append(fontLinkNode);
    }
};

registerInvestmentRobotElement();
